import { UseCustomAxios } from "../../UseCustomAxios";

export function UseLogOut() {
  const MyAxios = UseCustomAxios();

  const logout = (callback) => {
    MyAxios.get(`Admin_Logout`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback();
      }
    });
  };

  return {
    logout,
  };
}
